export const M_Toast = {
	icon: "exclamation-triangle",
	title: null,
	message: null,
	lifespan: "10s",
	accent: "surface",
}
